import SuperRepository from '../superRepository'

export default new (class TestApiRepository extends SuperRepository {
  baseUri() {
    return 'test_notification'
  }
  testApi = async (command, params = {}) =>
    this.httpClient().getFile(`${this.baseUri()}/run_command/${command}`, params)
})()
